import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import { combineReducers, configureStore, createStore } from "@reduxjs/toolkit";

import snackbarReducer from "Redux/snackbarReducer";
import messageReducer from "Redux/messageReducer";
import processReducer from "Redux/processReducer";
import priorityReducer from "Redux/priorityReducer"
import storage from "redux-persist/lib/storage";


import { persistReducer } from "redux-persist";


const persistConfig = {
    key: 'root',
    storage: storage,
    // Strip unknown keys (e.g. stale "robots" from a previous store shape)
    // so redux-persist rehydration doesn't warn about unexpected reducer keys.
    migrate: (state: any) => {
        if (!state) return Promise.resolve(state);
        const knownKeys = ["message", "process", "snackbar", "priority", "_persist"];
        const cleanState: any = {};
        Object.keys(state).forEach((key) => {
            if (knownKeys.includes(key)) cleanState[key] = state[key];
        });
        return Promise.resolve(cleanState);
    },
}


const rootReducer = combineReducers({
    message: messageReducer,
    process: processReducer,
    snackbar: snackbarReducer,
    priority: priorityReducer,

})

const persisted = persistReducer(persistConfig, rootReducer)
const store = configureStore({
    reducer: persisted,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})

export default store;
export type RootState = ReturnType<typeof store.getState>
